const isAllowedDayMonth = (values: any) => {
  const { floatValue, value } = values;
  return (!floatValue || floatValue <= 31) && value.length <= 2;
};

const isAllowedMonth = (values: any) => {
  const { floatValue, value } = values;
  return (!floatValue || floatValue <= 12) && value.length <= 2;
};

const isAllowedYear = (values: any) => {
  const { floatValue, value } = values;
  return (!floatValue || floatValue <= 9999) && value.length <= 4;
};

const generateYears = (numYears?: number, startAtOne?: boolean) => {
  const numberOfYears = numYears || 51;
  const years = Array.from({ length: numberOfYears }).map((_m, i) => {
    if (startAtOne) {
      i += 1;
    }
    const lbl = i === 1 ? 'Year' : 'Years';
    const monthItem = { value: i.toString(10), label: `${i} ${lbl}` };
    return monthItem;
  });

  return years;
};

const generateMonths = () => {
  const numberOfMonths = 12;
  const months = Array.from({ length: numberOfMonths }).map((_y, i) => {
    const lbl = i === 1 ? 'Month' : 'Months';
    const monthItem = { value: i.toString(10), label: `${i} ${lbl}` };
    return monthItem;
  });

  return months;
};

const getWeekDay = (index: number) => {
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  return days[index];
};

export { isAllowedDayMonth, isAllowedYear, isAllowedMonth, generateYears, generateMonths, getWeekDay };
